import { useState } from 'react';
import { Container, Orientation } from '@tcc/fds';
import { RegionReportItemHeader } from '../RegionReportItemHeader/RegionReportItemHeader';
import { RegionReportItems } from '../RegionReportItems/RegionReportItems';
import { ArdRegionReportItems } from '../RegionReportItems/ArdRegionReportItems';
import { ColorsMap, LabelColor, LevelTwoDimensionsList, RootLevelDimensionsList, YieldRegionReport } from '../../../../types';
import { SetItemCallback } from '../container/useRegionReportController';

export type RegionReportStatsProps = {
  allowHover?: boolean;
  areaUnit: string;
  colors?: LabelColor | ColorsMap;
  cropCode: string;
  data?: YieldRegionReport[] | RootLevelDimensionsList | LevelTwoDimensionsList;
  dataTestId: string;
  headerText: string;
  locale?: string;
  onClickItem?: SetItemCallback;
  showIcon?: boolean;
  index: number;
  displayRanges?: boolean;
  isArdData?: boolean;
  cropNominalWeight?: number | null;
};

export const RegionReportStats = ({
  allowHover,
  areaUnit,
  colors = [],
  cropCode,
  data = [],
  dataTestId,
  headerText,
  index,
  locale = '',
  onClickItem = undefined,
  showIcon = false,
  displayRanges = false,
  isArdData = false,
  cropNominalWeight,
}: RegionReportStatsProps) => {
  const [isCollapsed, toggleCollapsed] = useState(false);
  return (
    <Container width='100%' orientation={Orientation.Vertical}>
      <RegionReportItemHeader
        areaUnit={areaUnit}
        cropCode={cropCode}
        headerText={headerText}
        isCollapsed={isCollapsed}
        toggleCollapsed={() => toggleCollapsed(!isCollapsed)}
      />
      {!isCollapsed && !isArdData && (
        <RegionReportItems
          allowHover={allowHover}
          colors={colors as LabelColor}
          data={data as YieldRegionReport[]}
          dataTestId={dataTestId}
          locale={locale}
          index={index}
          onClickItem={onClickItem}
          showIcon={showIcon}
          displayRanges={displayRanges}
          cropCode={cropCode}
          cropNominalWeight={cropNominalWeight}
        />
      )}

      {!isCollapsed && isArdData && (
        <ArdRegionReportItems
          allowHover={allowHover}
          colors={colors as ColorsMap}
          data={data as RootLevelDimensionsList}
          dataTestId={dataTestId}
          locale={locale}
          index={index}
          onClickItem={onClickItem}
          showIcon={showIcon}
          displayRanges={displayRanges}
          cropCode={cropCode}
        />
      )}
    </Container>
  );
};


